import React, { useEffect } from "react";
import {
  IoReceiptOutline,
  IoOptionsOutline,
} from "react-icons/io5";

export function useOutsideAlerter(ref, open, setOpen) {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      const logoClass = event?.target?.className;
      if (logoClass && typeof logoClass !== "object") {
        if (logoClass?.indexOf("toggleIcon") !== -1) {
          setOpen(!open);
        } else if (ref?.current && !ref.current?.contains(event?.target)) {
          setOpen(open);
        }
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
}

export const setCookies = (key, value) => {
  // document.cookie = key + "=" + (value || "") + "; path=/";

  document.cookie = `${key}=${value}; path=/; max-age=604800; `;
};

export const getCookies = (key) => {
  const value = ("; " + document.cookie).split(`; ${key}=`).pop().split(";")[0];
  
  return value;
};

export const deleteCookies = (name) => {
  document.cookie =
    name +
    "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
};

export let sidebarDrawerInit = true;



export const handleSidebarDrawerInit = () => {
  sidebarDrawerInit = !sidebarDrawerInit;
  return sidebarDrawerInit;
};


export const sideBarList = [
  {
    label: "Dashboard",
    url: "",
    img: <img src={''} />,
  },
  {
    label: "Profile",
    url: "profile",
    img: <img src={''} />,
  },
  {
    label: "Game History",
    url: "game-history",
    img: <img src={''} />,
  },
];

export function getRandomNumbersFromArray(arr, count) {
  const result = new Set();
  while (result.size < count) {
    const randomIndex = Math.floor(Math.random() * arr.length) + 1;
    if (randomIndex == arr.length) {
      result.add(arr[randomIndex - 1]);
    } else {
      result.add(arr[randomIndex]);
    }
  }

  return Array.from(result);
}


export const initialData = {
  8: {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    min_value: 0,
    max_value: 0,
  },
};

export const list = [
  // {
  //   title: "Instant Bet",
  //   description: "",
  //   icon: <IoFlash color={"#181D29"} size={20} />,
  //   buttonName: "",
  //   icon2: <IoFlash color={"#fff"} className="mr-2" size={20} />,
  // },
  {
    title: "Max Bet",
    description: "",
    icon: <IoOptionsOutline color={"#181D29"} size={20} />,
    buttonName: "Enable",
    icon2: <IoOptionsOutline color={"#fff"} className="mr-2" size={20} />,
    maxBetDescription: "Are you sure want to enable the max bet button?"
  },
  {
    title: "Game Info",
    description: "",
    icon: <IoReceiptOutline color={"#181D29"} size={20} />,
    buttonName: "Rules",
    icon2: <IoOptionsOutline color={"#fff"} className="mr-2" size={20} />,
  },
];

export const riskOptionList = [
  { label: "Low", value: "low" },
  { label: "Medium", value: "medium" },
  { label: "High", value: "high" },
]


